import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Grid, Header, Image, Segment, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { REGEX_PATTERNS } from '../config/constants';
import { auth, logout } from '../helpers/auth';
import { AlertBox, askConfirmation, ConfirmBox, setAlertMsg } from '../components/Modals';

export default class Register extends Component {
  static propTypes = {
    history: PropTypes.any,
  }

  static defaultProps = {
    history: {},
  }

  state = {
    // loginMessage: null,
  }

  inputFields = {
    email: null,
    password: null,
    passwordConfirmation: null,
  }

  handleSubmit = (e) => {
    // console.log(this.inputFields.email, this.inputFields.password)
    e.preventDefault();
    if (!REGEX_PATTERNS.email.test(this.inputFields.email)) {
      return this.setState(setAlertMsg('auth/invalid-email', 'Impossible de créer le compte'));
    } else if (!this.inputFields.password) {
      return this.setState(setAlertMsg('auth/password-required', 'Impossible de créer le compte'));
    } else if (!this.inputFields.passwordConfirmation) {
      return this.setState(setAlertMsg(
        'auth/missing-password-confirmation',
        'Impossible de créer le compte',
      ));
    } else if (this.inputFields.passwordConfirmation !== this.inputFields.password) {
      return this.setState(setAlertMsg(
        'auth/passwords-mismatch',
        'Impossible de créer le compte',
      ));
    } else if (
      this.inputFields.password.length < 10
      || !/[A-Z]/.test(this.inputFields.password)
      || !/[a-z]/.test(this.inputFields.password)
      || !/\d/.test(this.inputFields.password)
    ) {
      return this.setState(setAlertMsg(
        'auth/weak-password',
        'Impossible de créer le compte',
      ));
    }
    return auth(this.inputFields.email, this.inputFields.password).then((user) => {
      user.sendEmailVerification();
      logout();
      this.setState(askConfirmation(
        'Compte créé avec succès',
        `Votre compte a bien été créé, mais nous devons vérifier que vous êtes bien le propriétaire de l'adresse email <em>${this.inputFields.email}</em> avant de vous autoriser l'accès à cette interface.<br/><br/>
Pour cela, <strong><span style="color:#e20000;">un lien d'activation vous a été envoyé par email</span></strong>.<br/><br/>
<strong>Votre compte ne sera activé qu'après avoir cliqué sur ce lien</strong>.<br/>Cet email peut mettre plusieurs minutes avant d'arriver dans votre messagerie organique.`,
        'success',
        () => { this.props.history.push('/login'); },
        'Poursuivre',
      ));
    })
      .catch((error) => {
        console.log(error);
        this.setState(setAlertMsg(error.code || null, 'Impossible de créer le compte'));
      });
  }

  render() {
    return (
      <div className="login-form">
        <style>
          {`
            body > div#root,
            body > div#root > div,
            body > div#root > div > div,
            body > div#root > div > div ,
            body > div#root > div > div > div.login-form {
              height: 100%;
            }
          `}
        </style>
        <Grid
          textAlign="center"
          style={{ height: '100%' }}
          verticalAlign="middle"
        >
          <Grid.Column style={{ maxWidth: 450 }}>
            <Image size="small" src="/images/web-logo.svg" centered verticalAlign="bottom" />
            <Header as="h2" textAlign="center" inverted>
              Créez votre compte
            </Header>
            <Form size="large" onSubmit={this.handleSubmit}>
              <Segment stacked>
                <p>Renseignez votre adresse professionnelle</p>
                <Form.Input
                  fluid
                  autoFocus
                  icon="user"
                  iconPosition="left"
                  onChange={(e) => {
                    this.inputFields.email = e.target.value.toLowerCase();
                  }}
                  placeholder="Adresse Email"
                  type="email"
                />
                <Form.Input
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="Mot de passe"
                  onChange={(e) => {
                    this.inputFields.password = e.target.value;
                  }}
                  type="password"
                />
                <Form.Input
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="Mot de passe (confirmation)"
                  onChange={(e) => {
                    this.inputFields.passwordConfirmation = e.target.value;
                  }}
                  type="password"
                />
                <Message size="mini">
                  <Message.Header>
                    Pour des raisons de sécurité, le mot de passe choisi doit :
                  </Message.Header>
                  <Message.List>
                    <Message.Item>Faire au moins 10 caractères</Message.Item>
                    <Message.Item>
                      Contenir au moins une minuscule, une majuscule et un
                      chiffre
                    </Message.Item>
                    <Message.Item>
                      Être différent du mot de passe utilisé pour votre accès à
                      l&apos;intranet
                    </Message.Item>
                  </Message.List>
                </Message>
                <Button fluid color="blue" type="submit">Créer le compte</Button>
              </Segment>
            </Form>
            <Segment basic className="whiteText">
              <Link to="/login" className="whiteText">Se connecter avec un compte existant</Link>
            </Segment>
          </Grid.Column>
        </Grid>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Register.js